import { Box, TextField, Typography } from '@mui/material'
import React from 'react'

interface Props {
  onCommentsChange: (comments: string) => void
}

const OverallComments = (props: Props) => {
  return (
    <Box sx={{
      backgroundColor: 'white',
      maxWidth: '1200px',
      padding: '24px',
      width: '100%',
      margin: '24px auto'
    }}>
      <Typography variant='h2'>
        Overall Comments
      </Typography>
      <TextField
        onChange={(event) => {
          props.onCommentsChange(event.target.value)
        }}
        multiline
        rows={3}
        sx={{
          width: '100%'
        }}
        />
    </Box>
  )
}

export default OverallComments
